const isValidObject = (object) => {
    if (!object || typeof object !== "object") {
      return false;
    }
    return true;
  };

export {isValidObject}